<template>
    <card class="m-0 p-0">
        <form v-loading.lock="saving" v-if="!success"
              :element-loading-text="$t('Saving...')">
            <div class="card-body row pt-0">
                <div class="col-12">
                    <div class="row">
                      <span class="pb-3 pl-3">{{ $t('We look forward to know your positive experiences you have with TeamWave and where you think we can improve. Thank you!') }}</span>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label>{{$t('Positive Experiences')}}</label>
                            <textarea v-model="positive" class="form-control pl-3" placeholder="" rows="8"/>
                        </div>
                        <div class="col-md-6">
                            <label>{{$t('Suggestions')}}</label>
                            <textarea v-model="negative" class="form-control pl-3" placeholder="" rows="8"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer text-right">
                <p-button round native-type="submit" type="primary" class="btn btn-fill btn-wd" :disabled="saving"
                          @click.prevent="save">
                    {{ $t('Send') }}
                </p-button>
            </div>
            <div class="clearfix"></div>
        </form>
        <center v-else>
          <h5>{{ $t('Thank you for your feedback!') }}</h5>
        </center>
    </card>
</template>

<script>
  import get from 'lodash/get'
  import axios from 'axios'

  export default {
    data () {
      return {
        positive: '',
        negative: '',
        saving: false,
        success: false
      }
    },
    components: {},
    methods: {
      save: async function () {
        this.saving = true
        await axios.put(`/api/userFeedback`, { positive: this.positive, negative: this.negative})
        this.saving = false
        this.success = true
      }
    },
    computed: {
    }
  }

</script>

<style lang="scss">
    .btn-icon-right {
        z-index: -1;
        padding: 0 !important;
    }
    .icon-right {
        z-index: 1;
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
    }
    .input-with-right-icon {
        border-right: 0 none !important;
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }
    .fa-icon-width {
        width: 20px !important;
    }
</style>
